import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Label,
  Card,
  CustomInput,
  Input,
  ButtonGroup,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import ReactDragListView from 'react-drag-listview';
import ImageGallery from '../../../propinfo/gallery/index';
import Switch from 'rc-switch';
import { List } from 'antd';
import 'antd/dist/reset.css';

const menuList = [
  { text: 'Menu', value: 'Menu' },
  { text: 'Address/Location', value: 'Location' },
  { text: 'Explore', value: 'Home' },
  { text: 'Media', value: 'Media' },
  { text: 'Ask Me', value: 'Bot' },
  { text: 'Profile', value: 'Profile' },
  // { text: "You Stay", value: "YouStay" },
];
export default function ManageMenu({ pageSettings, saveIntegration, locale }) {
  const [isHighLightShow, setIsHighLightShow] = useState(
    pageSettings.menuSetting !== null
      ? pageSettings.menuSetting.isHighLightShow
      : false
  );
  const [menuData, setMenuData] = useState([]);
  const [homeMenu, setHomeMenu] = useState('Home');
  const [errorMsg, setErrorMsg] = useState(false);
  const [botGalleryVisible, setBotGalleryVisible] = useState(false);
  const normalizeLocale = (l) => {
    if (l.startsWith('zh')) return 'zh';
    if (l.startsWith('hk')) return 'hk';
    return l;
  };

  const getLocalStatement = (statements) => {
    if (statements && statements.length > 0) {
      const index = statements.findIndex(
        (m) => normalizeLocale(m.locale) === normalizeLocale(locale)
      );
      if (index !== -1) return statements[index].statement;

      const englishIndex = statements.findIndex((m) => m.locale === 'en');
      if (englishIndex !== -1) return statements[englishIndex].statement;
    }
    return '';
  };
  useEffect(() => {
    var list = [];
    menuList.map((p, i) => {
      list.push({
        value: p.value,
        text: [{ statement: p.text, locale: 'en' }],
        checked: p.value === 'Menu' ? true : false,
        displayOrder: i,
      });
    });
    if (pageSettings.menuSetting !== null) {
      setHomeMenu(pageSettings.menuSetting.homeMenu);
    }
    if (
      pageSettings.menuSetting != null &&
      pageSettings.menuSetting.menus !== null &&
      pageSettings.menuSetting.menus.length > 0
    ) {
      var all = [];
      list.map((l) => {
        pageSettings.menuSetting.menus.map((m) => {
          if (
            l.value === m.value &&
            all.filter((a) => a.value === l.value).length === 0
          ) {
            all.push({ ...m, checked: true });
          }
        });
      });
      list.map((x) => {
        if (all.filter((a) => a.value === x.value).length === 0) {
          all.push({ ...x, checked: false });
        }
      });
      setMenuData(all.sort((a, b) => a.displayOrder - b.displayOrder));
    } else {
      var menus = list.map((m) => {
        if (list.filter((m) => m.checked === true).length < 4) {
          m.checked = true;
        }
        return m;
      });
      setMenuData(menus.sort((a, b) => a.displayOrder - b.displayOrder));
    }
  }, [menuList]);

  const handleTextChange = (e, value) => {
    const i = menuData.findIndex((m) => m.value === value);
    if (i === -1) return;
    const currentLocale = normalizeLocale(locale);
    const texts = menuData[i].text || [];
    const index = texts.findIndex(
      (m) => normalizeLocale(m.locale) === currentLocale
    );
    let updatedTexts;
    if (index === -1) {
      updatedTexts = [
        ...texts,
        {
          statement: e.target.value,
          locale: currentLocale,
        },
      ];
    } else {
      updatedTexts = [...texts];
      updatedTexts[index] = {
        ...updatedTexts[index],
        statement: e.target.value,
      };
    }
    const values = menuData.map((elem) => {
      if (elem.value === value) {
        return { ...elem, text: updatedTexts };
      }
      return elem;
    });
    setMenuData(values);
  };
  const handleHomeMenuChange = (e) => {
    setHomeMenu(e.target.value);
  };
  const handleRoleChange = (e) => {
    const values = menuData.map((elem) => {
      if (elem.value === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    var selectedCheck = values.filter((l) => l.checked === true).length;
    setErrorMsg(selectedCheck >= 4 ? false : true);
    setMenuData(values);
  };
  const handleSave = () => {
    var selectedCheck = menuData.filter((l) => l.checked === true);
    if (selectedCheck.length >= 4) {
      var settingMenu = [];
      selectedCheck.map((elem) => {
        settingMenu.push({
          text: elem.text,
          value: elem.value,
          displayOrder: elem.displayOrder,
          icon: elem.icon,
        });
      });
      var body = {
        isDisabled: false,
        homeMenu: homeMenu,
        menus: settingMenu,
        isHighLightShow: isHighLightShow,
      };
      pageSettings.menuSetting = body;
      saveIntegration({ pageSettings: pageSettings });
    } else {
      setErrorMsg(true);
    }
  };
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (fromIndex, toIndex, type, index) => {
    if (toIndex < 0) return;
    if (type === 'LIST-ITEM') {
      const categories = reorder(menuData, fromIndex + 1, toIndex + 1);
      var data = [];
      categories.map((item, i) => {
        data.push({
          ...item,
          displayOrder: i,
        });
      });
      setMenuData(data);
      var selectedCheck = data.filter((l) => l.checked === true);
      if (selectedCheck.length >= 4) {
        var settingMenu = [];
        selectedCheck.map((elem) => {
          settingMenu.push({
            text: elem.text,
            value: elem.value,
            displayOrder: elem.displayOrder,
          });
        });
        var body = {
          isDisabled: false,
          homeMenu: homeMenu,
          menus: settingMenu,
          isHighLightShow: isHighLightShow,
        };
        pageSettings.menuSetting = body;
        saveIntegration({ pageSettings: pageSettings });
      } else {
        setErrorMsg(true);
      }
    } else return new Error('NOT A VALID LIST');
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={botGalleryVisible}
                toggle={toggleBotgallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleBotgallery}>
                  Select Avatar
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedBotImage}
                    togglegallery={toggleBotgallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const toggleBotgallery = () => {
    setBotGalleryVisible(!botGalleryVisible);
  };
  const selectedBotImage = (image) => {
    if (image !== undefined) {
      const values = menuData.map((elem) => {
        if (elem.value === 'Bot') {
          elem.icon = image.src;
        }
        return {
          ...elem,
        };
      });
      setMenuData(values);
    }
  };
  const handleRemoveImage = () => {
    const values = menuData.map((elem) => {
      if (elem.value === 'Bot') {
        elem.icon = '';
      }
      return {
        ...elem,
      };
    });
    setMenuData(values);
  };
  console.log(menuData);
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody name="bodyClick text-center">
          <div className="col-md-12 text-center my-3">
            <h4> Manage Menu</h4>
            <p className="mb-4">Choose the menu items you want to display</p>
          </div>
          <Separator className="mb-2" />
          <div className="col-md-12 mb-3">
            <Row>
              <Colxx xxs="4" className="mt-1">
                <Label>Available Options</Label>
              </Colxx>
              <Colxx xxs="5" className="mt-1">
                <Label>Menu Title</Label>
              </Colxx>
              <Colxx xxs="3" className="mt-1">
                <Label>Home Menu</Label>
              </Colxx>
            </Row>
            {menuData.length > 0 && (
              <Fragment>
                {menuData
                  .filter((l) => l.value === 'Menu')
                  .map((elem, index) => (
                    <Row key={`buttonRow~${index}`}>
                      <Colxx xxs="4" className="mt-1 d-flex">
                        <CustomInput
                          key={`buttonChk~${index}`}
                          type="checkbox"
                          value={elem.value}
                          id={elem.value}
                          onChange={handleRoleChange}
                          checked={elem.checked}
                          disabled={elem.value === 'Menu' ? true : false}
                        >
                          {getLocalStatement(elem.text)}
                        </CustomInput>
                      </Colxx>
                      <Colxx xxs="5" className="mt-1">
                        {elem.checked ? (
                          <Input
                            key={`buttontText~${index}`}
                            type="text"
                            value={getLocalStatement(elem.text)}
                            name={elem.value}
                            onChange={(e) => handleTextChange(e, elem.value)}
                          />
                        ) : null}
                      </Colxx>
                      <Colxx xxs="3" className="mt-1">
                        {/* {elem.checked && elem.value !== "Bot" ? <CustomInput
                                            className="ml-4"
                                            key={`buttonChk~${index}`}
                                            type="checkbox"
                                            value={elem.value}
                                            id={elem.value}
                                            onChange={handleHomeMenuChange}
                                            checked={homeMenu === elem.value ? true : false}
                                        ></CustomInput>
                                            : null} */}
                      </Colxx>
                    </Row>
                  ))}
                <ReactDragListView
                  nodeSelector=".draggable-item"
                  lineClassName="dragLine"
                  onDragEnd={(fromIndex, toIndex) => {
                    const draggableItems = menuData.filter(
                      (item) => item.checked && item.value !== 'Menu'
                    );
                    const reordered = reorder(draggableItems, fromIndex, toIndex);
                    const newMenuData = menuData.map((item) => {
                      const found = reordered.find((r) => r.value === item.value);
                      return found ? { ...found } : item;
                    });
                    const finalMenuData = newMenuData.map((item, index) => ({
                      ...item,
                      displayOrder: index,
                    }));

                    setMenuData(finalMenuData);
                    const selectedCheck = finalMenuData.filter((l) => l.checked);
                    if (selectedCheck.length >= 4) {
                      const settingMenu = selectedCheck.map((elem) => ({
                        text: elem.text,
                        value: elem.value,
                        displayOrder: elem.displayOrder,
                      }));

                      pageSettings.menuSetting = {
                        isDisabled: false,
                        homeMenu,
                        menus: settingMenu,
                        isHighLightShow,
                      };
                      saveIntegration({ pageSettings });
                    } else {
                      setErrorMsg(true);
                    }
                  }}
                >
                  {menuData
                    .filter((item) => item.checked && item.value !== 'Menu')
                    .map((elem, index) => (
                      <List key={elem.value} className="draggable-item">
                        <Row key={elem.value}>
                          <Colxx xxs="4" className="mt-1 d-flex">
                            {elem.checked && (
                              <span className="mr-2 draggable">
                                <a href="#">
                                  <i className="simple-icon-menu"></i>
                                </a>
                              </span>
                            )}
                            <CustomInput
                              type="checkbox"
                              value={elem.value}
                              id={elem.value}
                              onChange={handleRoleChange}
                              checked={elem.checked}
                            >
                              {getLocalStatement(elem.text)}
                            </CustomInput>
                          </Colxx>
                          <Colxx xxs="5" className="mt-1">
                            {elem.checked ? (
                              <Input
                                key={`buttontText~${index + 1}`}
                                type="text"
                                value={getLocalStatement(elem.text)}
                                name={elem.value}
                                onChange={(e) => handleTextChange(e, elem.value)}
                              />
                            ) : null}
                          </Colxx>
                          <Colxx xxs="3" className="mt-1">
                            {elem.checked && elem.value !== 'Bot' ? (
                              <CustomInput
                                className="ml-4"
                                type="checkbox"
                                value={elem.value}
                                id={elem.value + '-home'}
                                onChange={handleHomeMenuChange}
                                checked={homeMenu === elem.value ? true : false}
                              />
                            ) : (
                              elem.value === 'Bot' && (
                                <Fragment>
                                  {elem.icon === null || elem.icon === '' ? (
                                    <Button
                                      color="success"
                                      size="xs"
                                      className="mt-1"
                                      onClick={toggleBotgallery}
                                    >
                                      Browse Logo
                                    </Button>
                                  ) : (
                                    <div className="thumbnail t-bot">
                                      <img
                                        className="list-thumbnail thumbnail-bot responsive border-0"
                                        src={elem.icon}
                                      />
                                      <a
                                        href="#/"
                                        className="remove"
                                        data-dz-remove
                                        onClick={() => handleRemoveImage()}
                                      >
                                        {' '}
                                        <i className="glyph-icon simple-icon-trash" />{' '}
                                      </a>
                                    </div>
                                  )}
                                </Fragment>
                              )
                            )}
                          </Colxx>
                        </Row>
                      </List>
                    ))}
                </ReactDragListView>
                {menuData
                  .filter((l) => l.value !== 'Menu' && l.checked === false)
                  .map((elem, index) => (
                    <Row key={`buttonRow~${index}`}>
                      <Colxx xxs="4" className="mt-1 d-flex">
                        <CustomInput
                          key={`buttonChk~${index}`}
                          type="checkbox"
                          value={elem.value}
                          id={elem.value}
                          onChange={handleRoleChange}
                          checked={elem.checked}
                        >
                          {getLocalStatement(elem.text)}
                        </CustomInput>
                      </Colxx>
                      <Colxx xxs="5" className="mt-1">
                        {elem.checked ? (
                          <Input
                            key={`buttontText~${index}`}
                            type="text"
                            value={getLocalStatement(elem.text)}
                            name={elem.value}
                            onChange={(e) => handleTextChange(e, elem.value)}
                          />
                        ) : null}
                      </Colxx>
                      <Colxx xxs="3" className="mt-1">
                        {elem.checked && elem.value !== 'Bot' ? (
                          <CustomInput
                            className="ml-4"
                            key={`buttonChk~${index}`}
                            type="checkbox"
                            value={elem.value}
                            id={elem.value}
                            onChange={handleHomeMenuChange}
                            checked={homeMenu === elem.value ? true : false}
                          ></CustomInput>
                        ) : null}
                      </Colxx>
                    </Row>
                  ))}
              </Fragment>
            )}
          </div>
          {errorMsg && (
            <span className="text-danger">
              You must have to check minimum 4 menus
            </span>
          )}
          <div className="col-md-12 mb-3">
            <Switch
              className="custom-switch-primary custom-switch-small"
              checked={isHighLightShow}
              onChange={(primary) => setIsHighLightShow(primary)}
            />{' '}
            <span>Show Highlights</span>
          </div>
          <Separator className="mt-2 " />
          <div className="d-flex justify-content-center mb-2">
            <ButtonGroup
              className="mb-2 text-center"
              style={{ marginTop: '40px' }}
            >
              <Button color="primary" size="xs" onClick={handleSave}>
                Save
              </Button>
            </ButtonGroup>
          </div>
        </CardBody>
      </Card>
      {ImageGalleryButton()}
    </Fragment>
  );
}
